import React from "react";
//#region redux
import { AppState } from "store";
import { useSelector, useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { loadCompaniesAsync } from "store/actions/authActions";
//#endregion
//#region types
import { AllCompaniesConstants } from "utils/constants";
//#endregion
//#region components
import CompanyList from "./companyList";
import { useNavigate } from "react-router-dom";
import { SelectChangeEvent } from "@mui/material";
//#endregion

const CompanyListContainer: React.FC = (props) => {
  const navigate = useNavigate();
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const [selectedCompany, setSelectedCompanyUrl] = React.useState<string>();

  const { companyList, selectedCompanyUrl } = useSelector((store: AppState) => ({
    companyList: store.auth.companies,
    selectedCompanyUrl: store.auth.selectedCompany.url,
  }));

  const onChange = (event: SelectChangeEvent<string>) => {
    const url = event.target.value;

    if (url === AllCompaniesConstants.CompanySelectorValue) {
      navigate(`/${selectedCompanyUrl}/${AllCompaniesConstants.TodoOverviewPath}`);
      return;
    }

    navigate(`/${url}`);
    setSelectedCompanyUrl(url as string);
  };

  React.useEffect(() => {
    if (selectedCompanyUrl !== selectedCompany) {
      setSelectedCompanyUrl(selectedCompanyUrl);
    }
  }, [selectedCompanyUrl]);

  const loadCompanies = () => dispatch(loadCompaniesAsync() as unknown as Promise<number>);

  const showAllCompaniesOption = useSelector((store: AppState) => store.auth.showAllCompaniesTodoOverview === true);

  return (
    <CompanyList
      companyList={companyList}
      showAllCompaniesOption={showAllCompaniesOption}
      selectedCompanyUrl={selectedCompany}
      loadCompanies={loadCompanies}
      onChange={onChange}
      chevronIcon
      keyboardSupport
    />
  );
};

export default CompanyListContainer;
